import { Box, Chip, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useMemo, useState } from "react";
import { TConfigSelect } from "..";
import { useQuery } from "react-query";
import axiosClient from "../../../lib/axios";
import useBaseUrl from "../../../lib/useBaseUrl";
import DialogEditImage from "./DialogEditImage";

import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import EditIcon from '@mui/icons-material/Edit';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined';
import PermissionGuard, { usePermission } from "../../../components/PermissionGuard";

export default function SideMenu({
    select,
    handleSelect
}: SideMenuProps) {

    const colorIcon = useMemo(() => "black", [])
    const primeiroParam = useBaseUrl();

    const [editImageModal, setEditImageModal] = useState(false)

    const menuList: TMenuList = [
        { label: "Dashboard", icon: <DashboardOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.dashboard") },
        { label: "Usuários", icon: <PersonOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.usuarios") },
        { label: "Perfis", icon: <ManageAccountsOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.perfis") },
        { label: "Formulários", icon: <DynamicFormOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.formularios"), disabled: true },
        { label: "Fluxos", icon: <MoveUpOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.fluxos") },
        { label: "Integração WhatsApp", icon: <WhatsAppIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.whatsapp") },
        { label: "Mensagens", icon: <MessageOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.mensagens") },
        { label: "Copy Norte", icon: <FolderOutlinedIcon sx={{ color: colorIcon }} />, havePermission: usePermission("configuracoes.copynorte") },
    ]

    //Querys e Mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-imagem-cooperativa"],
        queryFn: () => axiosClient.get("/pesquisar-imagem-cooperativa", {
            params: {
                dominio: primeiroParam
            },
        }),
        cacheTime: 0
    });
    //
    const dataImagens: TDataImagens = useMemo(() => {
        return data?.data || {};
    }, [data]);

    return (
        <>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <Box width={150} height={150}
                    display={'flex'} justifyContent={'center'} alignItems={'center'}
                    bgcolor={'#f5f5f5'} borderRadius='50%' border={'1px solid #ccc'}>
                    <img
                        src={dataImagens.logo_image ? dataImagens.logo_image : '/imgs/image-not-found.png'}
                        alt="Logo"
                        style={{
                            width: 100, height: 100, transform: 'scale(0.9)', objectFit: 'cover',
                            objectPosition: 'center bottom',
                        }}
                    />
                </Box>
                <Box
                    component={'button'}
                    onClick={() => setEditImageModal(true)}
                    border={'none'}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="#1b5e20"
                    width={35}
                    height={35}
                    borderRadius="50%"
                    ml={12}
                    mt={-3.5}
                    zIndex={1}
                    sx={{
                        alignSelf: "center",
                        cursor: "pointer"
                    }}
                >
                    <EditIcon fontSize="small" sx={{ color: "white" }} />
                </Box>
            </Box>

            <PermissionGuard permissionId="configuracoes.dashboard">
                <List sx={{ mt: 4 }}>
                    {
                        menuList.map((item, index) => {
                            const itemSelecionado = item.label === select

                            if (!item.havePermission) return <></>

                            return (
                                <ListItem
                                    disablePadding
                                    key={index}
                                    sx={{ backgroundColor: itemSelecionado ? "#F0F0F0" : "unset" }}
                                >
                                    <ListItemButton
                                        disabled={item.disabled}
                                        onClick={() => !item.disabled && handleSelect(item.label)}
                                    >
                                        <ListItemIcon>
                                            {item.icon}
                                        </ListItemIcon>

                                        <ListItemText
                                            primary={
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    {item.label}
                                                    {item.disabled && (
                                                        <Chip
                                                            label="Em breve"
                                                            color="primary"
                                                            variant="outlined"
                                                            sx={{
                                                                fontSize: '0.7rem',
                                                                height: 20,
                                                                '& .MuiChip-label': {
                                                                    px: 1
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            }
                                        />

                                        <KeyboardArrowRightIcon sx={{ color: "black" }} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })
                    }
                </List>
            </PermissionGuard>
            {
                editImageModal && !isLoading &&
                <DialogEditImage
                    {...{ dataImagens }}
                    open={editImageModal}
                    onClose={() => {
                        setEditImageModal(false);
                    }}
                />
            }
        </>
    )
}

interface SideMenuProps {
    select: TConfigSelect
    handleSelect: (arg: TConfigSelect) => void
}

type TMenuList = Array<{
    label: TConfigSelect,
    icon: JSX.Element,
    havePermission: boolean,
    disabled?: boolean
}>

export type TDataImagens = {
    logo_image: string | null,
    cover_image: string | null,
    possui_imagem_fatura: boolean,
}
